import { formatNumber } from "./formatNumber";

export function formatNumberAsMoney(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  amount: any,
  style: "currency" | "decimal" = "currency",
  currency: string = "EUR",
  locale: string = "nl-NL",
): string {
  const result = formatNumber(amount, locale, {
    decimals: true,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    currency: style === "currency" ? currency : undefined,
  });

  if (result.endsWith(",00")) {
    return result.slice(0, -3); // + ",-";
  }

  return result;
}
